import React from "react";
import "./WhyNobel.css";
import { Link } from "react-router-dom";

const WhyNobel = ({ variant }) => {
  return (
    <section className="why-nobel-section">
      <img
        src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/UXks7sCBKzljAT69qmhD/media/151ede1c-63db-40f6-9f0f-e2bad80e7637.png"
        alt="Decorative Line"
        className="why-nobel-top-line"
      />

      {/* Top Section */}
      <div className="why-nobel-container">
        <div className="why-nobel-image">
          <img
            src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/UXks7sCBKzljAT69qmhD/media/f4e7f1bb-62cb-49f5-83d8-0675bbcbcc39.png"
            alt="Lawyer Presentation"
          />
        </div>
        <div className="why-nobel-content">
          <h2>Why Nobel AI Legal?</h2>
          <p>
            We simplify legal work for Personal Injury Lawyers with AI-powered
            solutions that:
          </p>
          <ul>
            <li>
              <strong>40% Faster Case Processing</strong>
              <span>AI automation reduces delays.</span>
            </li>
            <li>
              <strong>99% Data Accuracy</strong>
              <span>Eliminate manual errors with intelligent legal tools.</span>
            </li>
            <li>
              <strong>Seamless Integration</strong>
              <span>Connect legal, medical, and insurance data instantly.</span>
            </li>
            <li>
              <strong>Secure & Scalable</strong>
              <span>Designed specifically for law firms of all sizes.</span>
            </li>
          </ul>
          <Link to="/contact" className="consult-button">
            Book A Consultation ➤
          </Link>
        </div>
      </div>

      {/* Bottom Section - only render if variant is NOT "top" */}
      {variant !== "top" && (
        <div className="why-nobel-container reverse">
          <div className="why-nobel-content">
            <h2>Personal Injury Solutions</h2>
            <h4>Streamline Personal Injury Case Management with AI</h4>
            <p>
              Nobel AI Legal is the all-in-one platform designed for Personal
              Injury Lawyers, helping you manage Accident Benefits and TORT
              Claims effortlessly.
              <br />
              <br />
              Our AI-powered system automates case tracking, document
              management, and client communication — all in one secure platform.
              Say goodbye to manual tasks and outdated processes, and focus more
              on winning cases and delivering results.
              <br />
              <br />
              Experience a smarter, faster way to manage your firm with Nobel AI
              Legal.
            </p>
          </div>
          <div className="why-nobel-image">
            <img
              src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/UXks7sCBKzljAT69qmhD/media/a5ec7804-5008-415e-aec1-250c49438d37.png"
              alt="Personal Injury"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default WhyNobel;
